import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SSOAuthComponent } from './sso-auth.component';

const routes: Routes = [
  {
    path: '',
    component: SSOAuthComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SSOAuthRoutingModule { }
